<template>
  <div class="advice">
     <!-- banner -->
    <sbanner :detailInfo="detailInfo"></sbanner>

    <div class="container">
      <div class="advice-content" v-if="!adviceSucess">
        <div class="advice-title">意见反馈</div>
        <div class="advice-form">
          <div class="form-item">
            <div class="label">反馈标题<em>*</em></div>
            <div class="form-box">
              <input type="text"  v-model="title" placeholder="请输入标题">
              <!-- <p>{{type}} > {{name}}</p> -->
            </div>
          </div>
          <div class="form-item">
            <div class="label">反馈内容<em>*</em></div>
            <div class="form-box">
              <textarea v-model="feedback" maxlength=400 placeholder="请输入留言" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">您的意见</div>
            <div class="form-box">
              <textarea v-model="advice" maxlength=400  placeholder="请输入留言"/>
            </div>
          </div>
          <div class="form-item">
            <div class="label">联系电话<em>*</em></div>
            <div class="form-box">
                <input type="text"  v-model="tel" placeholder="请输入手机号">
            </div>
          </div>

          <div class="form-item ">
            <div class="label">补充材料</div>
            <div class="form-box">
                <div class="upBtn" v-if="!fileInfo">
                  <input type="file" title="请选择文件" class="uploadBtn" ref="fileadd" @change="getfile" :accept="accept" />
                  <div class="uploadBtn2" @click="middleFile">点击上传</div>
                </div>
                <div class="showFiles" v-if="fileInfo" >
                  <div class="file-item images" v-if="fileInfo.type =='image'">
                    <span class="close" @click="deleteFile"><em class="iconfont icon-close-fill"></em></span>
                    <div class="file-box" @click="previewFile(showpath + fileInfo.src)">
                      <img :src="showpath + fileInfo.src" alt="" />
                    </div>
                  </div>
                  <div class="file-item files" v-else>
                    <p class="filename">{{fileInfo.filename}}</p>
                    <span class="look" @click="previewFile(fileInfo)">查看</span>
                    <span class="delete" @click="deleteFile">删除</span>
                  </div>
                </div>
            </div>
          </div>

          <div class="form-item" v-if="false">
            <div class="label">验证码 <em>*</em></div>
            <div class="form-box">
              <input type="text" class="verifyInput" v-model="verify">
              <img :src="sbannerPic" class="verifyImg" alt="">
            </div>
          </div>
        </div>
        <transition name="fade">
          <notice  v-if="noticeShow">
            <template v-slot:noticeTxt>
              {{noticeTxt}}
            </template>
          </notice>
        </transition>
        <div class="form-btns">
          <div class="default-btn" @click="reset">重置内容</div>
          <div class="default-btn surebtn" @click="submit">确认提交</div>
        </div>
      </div>

      <div class="advice-content" v-else>
        <div class="advice-title">意见反馈</div>
        <div class="advice-success">
          <p class="advice-icon">
            <span class="iconfont icon-check"></span>
          </p>
          <p class="advice-state" >提交成功！</p>
          <p>工作人员将会在第一时间评估处理，感谢您的热心反馈！</p>
        </div>
      </div>
    </div>
    <popInfo v-if="popShow">
      <p>{{popTxt}}</p>
    </popInfo>

    <div class="imgPre" v-if="showPre" @click="closePre">
      <!-- <span class="close iconfont icon-close-fill"  @click="closePre"></span> -->
      <img :src="showpath + fileInfo.src" alt="">
    </div>
  </div>
</template>

<script>
import sbanner from '../components/sbanner.vue'
import Notice from '../components/common/notice.vue'
import popInfo from "../components/common/popInfo.vue"
export default {
  name: 'advice',
  components:{sbanner, Notice, popInfo },
  data(){
    return{
      detailInfo:{},
      title:'',
      feedback:'',
      advice:'',
      tel:'',
      verify:'',
      noticeShow:false,
      noticeTxt:'',
      name:'',
      id:0,
      type:'',
      adviceSucess:false,
      accept:"image/*,application/zip,.zip,application/rar,.rar,application/7z,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/pdf,application/msword,text/plain,text/csv,audio/mpeg,audio/3gpp,video/3gpp,audio/mp4,video/mp4,application/ogg,audio/ogg,.docx,.pptx,.xlsx,.pdf",
      popShow: false,
      popTxt: '',
      fileInfo:null,
      showPre: false,
      
    }
  },
  watch:{
    "feedback":{
      handler:function(newv,oldv){
          if(newv.length >=400){
            this.noticeTxt="您输入的内容过多，请不要超过400字"
            this.noticeShow =true;
            this.hideNotice()
          }
      },
      deep:true
    },
    "advice":{
      handler:function(newv,oldv){
          if(newv.length >=400){
            this.noticeTxt="您输入的内容过多，请不要超过400字"
            this.noticeShow =true;
             this.hideNotice()
          }
      },
      deep:true
    },

  },
  mounted() {
    this.name = this.$route.query.name;
    this.id= this.$route.query.id;
    this.type =this.$route.query.source
  },
  methods: {
    middleFile(){
      this.$refs.fileadd.click()
    },
    getfile(e){
      let that = this;
      let file = e.target.files[0]
      console.dir(file)
      if(!file) return
      // 判断上传文件格式是否正确
      let fileRight = this.$utils.fileInclude(file)
      
      if(!fileRight) {
        alert("请上传正确的文件")
        return
      }
      if(Math.floor(file.size / 1024) > 1024*1024){
        alert("请选择1G以内的文件！")
        return
      }
      
      let param = new FormData()  // 创建form对象
      param.append('file', file)  // 通过append向form对象添加数据
      param.append('chunk', '0') // 添加form表单中其他数据
      this.popTxt = "上传中...";
      this.popShow = true;
      let params ={
        username:"",
        phone:"",
        param: param,
      }
      this.$api.userApi.Upload(params).then(res=>{
        if(res.data.code==0 && res.data.url){
          this.showpath = res.data.showpath
          this.fileInfo = {
            showpath:res.data.showpath,
            src: res.data.url,
            souceType :file.type,
            type:this.$utils.fileType(file.type),
            filename:file.name
          }
        }
        this.popTxt = res.data.msg
        this.popShow = true
        setTimeout(() => {
            this.popShow = false
        }, 2000);
      }).catch(msg=>{
        console.dir("错误",msg)
      })
      
    },

    deleteFile(e){
        this.fileInfo=null
    },
    // 预览
    previewFile(fileinfo){
      if(typeof fileinfo =='string'){
        this.showPre = true;
        return
      }
      console.log(fileinfo)
      // window.location.href=this.showpath + fileinfo.src
       window.open(this.showpath + fileinfo.src, '_blank');
    },
    closePre(e) {
      this.showPre = false;
    },

    reset(){
      this.feedback='';
      this.advice="";
      this.verify="";
      this.title="";
      this.tel =''
      this.fileInfo = null
    },
    submit(){
      // 验证
      if(!this.title || !this.title.trim()){
        this.noticeTxt="反馈标题不能为空！"
        this.noticeShow =true;
        return;
      }
      if(!this.feedback || !this.feedback.trim()){
        this.noticeTxt="反馈内容不能为空！"
        this.noticeShow =true;
        return;
      }
      if(!this.tel || !this.tel.trim()){
        this.noticeTxt="联系电话不能为空！"
        this.noticeShow =true;
        return; 
      }
      let reg =/^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
      let reg2 =/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
      if(this.tel){
        if(!reg.test(this.tel) && !reg2.test(this.tel)){
        this.noticeTxt='请填写正确电话格式'
        this.noticeShow =true;
        return false;
      }
      }
      

      let params={
        title:this.title,
        feedback:this.feedback,
        suggestion:this.advice,
        phone:this.tel,
        file_path: this.fileInfo ? this.fileInfo.src : ""
      }
      this.$api.suggestionApi.toSuggestion(params).then(res=>{
        if(res.code===0){
          this.adviceSucess = true;
        }
      })
    },
    
    hideNotice(){
      setTimeout(() => {
        this.noticeShow=false;
        this.noticeTxt=''
      }, 2000);
      
    }
  },
}
</script>